export enum MediaField
{

    TOKEN           =   "token"                 ,

    CONTENT_LENGTH  =   "content-length"        ,
    FILE            =   "file"                  ,
    TYPE            =   "type"                  ,
    CODE            =   "code"                  ,
    DESCRIPTION     =   "description"           ,

    LEVEL           =   "level"                 ,
    LEVELID         =   "levelid"               ,

}